import { render, staticRenderFns } from "./VFrame.vue?vue&type=template&id=c604dc74&"
import script from "./VFrame.vue?vue&type=script&lang=js&"
export * from "./VFrame.vue?vue&type=script&lang=js&"
import style0 from "./VFrame.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports